import type { CSSProperties } from 'react';

// Section kicker — Caveat label above each section heading (e.g. "pricing", "ai chat")
export const sectionKicker: CSSProperties = {
  fontFamily: 'Caveat, cursive',
  fontSize: '20px',
  fontWeight: 600,
  color: 'var(--vi-accent-primary)',
};

// Section heading — primary H2 used for every landing page section title
export const sectionHeading: CSSProperties = {
  fontFamily: 'Lora, Georgia, serif',
  fontSize: 'clamp(32px, 4vw, 52px)',
  fontWeight: 700,
  color: 'var(--vi-text-primary)',
  letterSpacing: '-0.025em',
  lineHeight: 1.1,
  fontStyle: 'italic',
};

// Section subtitle — Nunito body copy that sits beneath a section heading
export const sectionSubtitle: CSSProperties = {
  fontFamily: 'Nunito, sans-serif',
  fontSize: '17px',
  fontWeight: 400,
  color: 'var(--vi-text-body)',
  lineHeight: 1.7,
};

// Card heading — Lora H3 used inside feature cards and sub-sections
export const cardHeading: CSSProperties = {
  fontFamily: 'Lora, Georgia, serif',
  fontSize: '24px',
  fontWeight: 600,
  color: 'var(--vi-text-primary)',
  letterSpacing: '-0.01em',
  lineHeight: 1.25,
};
